import { render, staticRenderFns } from "./ModalEdicaoFalhaRetorno.vue?vue&type=template&id=86f24cf6&scoped=true"
import script from "./ModalEdicaoFalhaRetorno.vue?vue&type=script&lang=js"
export * from "./ModalEdicaoFalhaRetorno.vue?vue&type=script&lang=js"
import style0 from "./ModalEdicaoFalhaRetorno.vue?vue&type=style&index=0&id=86f24cf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f24cf6",
  null
  
)

export default component.exports